<div class="big855-model">
    <table class="model-table">
        <tbody>
            <tr>
                <td>
                    <div class="model-title i18n" data-tag="changePassword">{{ 'dialog-box-header.change_password' |
                        translate}}</div>

                    <button class="btn-close login-close" (click)="onClose()">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </td>
            </tr>

            <tr>
                <td class="model-login-body">
                    <div class="body-content">

                        <!-- Form -->
                        <form [formGroup]="frmChgPw" (ngSubmit)="changeNow()" class="form-list" novalidate>
                            <div class="item">
                                <span class="item-icon">
                                    <i class="fa fa-user"></i>
                                </span>
                                <input type="password" name="oldPassword" class="input i18n-input sm-user"
                                    data-tag="oldPassword" placeholder="{{
                                  'accounts.password.old_password' | translate
                                }}" minlength="1" maxlength="14" formControlName="oldPassword" />
                            </div>

                            <div class="item">
                                <span class="item-icon">
                                    <i class="fa-solid fa-lock"></i>
                                </span>
                                <input type="password" name="newPassword" class="input i18n-input sm-user"
                                    data-tag="newPassword" placeholder="{{
                                  'accounts.password.new_password' | translate
                                }}" minlength="1" maxlength="14" formControlName="newPassword" />
                            </div>


                            <div class="item">
                                <span class="item-icon">
                                    <i class="fa-solid fa-lock"></i>
                                </span>
                                <input type="password" name="confirmPassword" class="input i18n-input sm-user"
                                    data-tag="confirmPassword" placeholder="{{
                                  'accounts.password.confirm_password' | translate
                                }}" minlength="1" maxlength="14" formControlName="confirmPassword" />
                            </div>

                            <div class="item">
                                <button type="submit" class="btn btn-primary i18n" data-tag="changePassword">
                                  {{ 'accounts.password.submit' | translate }}
                                </button>
                              </div>

                        </form>



                    </div>
                </td>
            </tr>

        </tbody>
    </table>



</div>